/* eslint-disable max-len */
/**
 * 首页课程模块配置
 */
export default {
  banner: {
    title: 'Give Your Child A Competitive Edge',
    description: 'Offering accelerated learning in maths and science, Think Academy fosters your children\'s ability to think critically, strengthens their logic skills, and helps them fulfill their goals through innovative teaching techniques.',
    className: '',
  },
  offlineClassroomImgs: [
    'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/common/offline-classroom-1.jpg',
    'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/common/offline-classroom-2.jpg',
    'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/common/offline-classroom-3.jpg',
    'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/common/offline-classroom-4.jpg',
  ],
  teachingToolVideoUrl: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/common/teachingToolIntroVideo.mp4',
  classIntroduction: {
    Maths: {
      longTermCourses: {
        title: 'Think Academy Year-Round Accelerate Math Course',
        introduction: `Think Academy’s Year-Round Classes teaches 7 modules, which cover the 7 essential math concepts taught in the U.S.:
        Number Theory, Combinatorics, Geometry, Number System & Operation, Word Problem Solving, Statistics & Probability, and Algebra.
        <p>By the end of a Think Academy Year-Round Class, students will have a strong understanding of mathematics, and know topics and calculation strategies that are covered in elementary school math competitions.</p>`,
        levels: [
          {
            levelName: 'Enhancement',
            bg: '#FB9068',
            levelIntroduction: 'Leveled with regular class at the top private school.',
          },
          {
            levelName: 'Advancement',
            bg: '#FDBA48',
            levelIntroduction: 'Leveled with top private school\'s highest placement level.',
          },
          {
            levelName: 'Mastery',
            bg: '#3370FF',
            levelIntroduction: 'Three years ahead of public schools, one year of top private schools\' highest placement level.',
          },
          {
            levelName: 'ACE',
            bg: '#3A4AD8',
            levelIntroduction: 'Designed for top talents in maths. Preparing to attend international-level mathematic contests in secondary school.',
          },
        ],

      },
      shortTermCourses: {
        title: 'Think Academy Short Term Courses',
        introduction: ' Our Short Term Courses are accelerated math classes that focus on specific learning outcomes. From learning how to understand and solve word problems, to preparing for the AMC 8, each of Think Academy’s Short Term Courses are tailored to help children meet specific learning goals in their appropriate grade. <p>Think Academy’s Short-Term Courses are also designed to increase student’s interest in math and learning, with fun games and teaching methods.</p>',
        shortTermImgs: [
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/shortTermCourse1.jpg',
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/shortTermCourse2.jpg',
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/shortTermCourse3.jpg',
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/shortTermCourse4.jpg',
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/shortTermCourse5.jpg',
        ],
      },
      basicMathCourses: {
        title: 'Basic Math Foundation Year-Round Course',
        introduction: 'Think Academy’s Basic Math courses is a year around class that offer curriculum that meet private school standards. Each month Basic Math will enter a different module and dive deep in the module knowledge. This class prepare students for questions included in the ISEE lower level exam and other standardized tests.<p>By the end of our Basic Math course, your son or daughter will be on the path to educational success and feel confident solving math problems taught in their grade at the private school level, as well as solving popular ISEE math problems.</p>',
        basicMathImgs: [
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/basicMath1.jpg',
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/basicMath2.jpg',
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/basicMath3.jpg',
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/basicMath4.jpg',
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/basicMath5.jpg',
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/basicMath6.jpg',

        ],
      },
      activities: {
        title: 'November Short-Term Courses',
        // introduction: 'Think Academy has various activities such as Thinklive free STEM classes for students to learn at home; Grade-specific trial class to taste our interactive and fun think-academy learning experience; Parent Seminar to find out the latest learning trends and how to excel in math journey and many more!',
        activityImgs: [
          'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/November_short-term.jpg',
          // 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/activity2.jpg',
          // 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/activity3.jpg',
          // 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/activity4.jpg',
          // 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/activity5.jpg',
        ],
      },
    },
    Chinese: {
      levels: [
        {
          title: 'Chinese Level 2 Courses',
          target: 'PreK - Grade 2',
          session: '1.5 hours/session, 15 Sessions',
          goal: 'Benchmarking the HSK/YCT test, our courses are developed specifically for oversea young Chinese learners.',
        },
        {
          title: 'Chinese Level 3 Courses',
          target: 'Grade 2 - Grade 5',
          session: '2 hours/session, 15 Sessions',
          goal: 'Benchmarking the HSK/YCT test, our courses are developed specifically for oversea young Chinese learners.',
        },
      ],
      laddersNames: [
        { name: '级别', ladderName: 'levelName' },
        { name: '识字目标', ladderName: 'literacyGoal' },
        { name: '沟通表达', ladderName: 'communication' },
        { name: '识字阅读', ladderName: 'communication' },
        { name: '文化文学', ladderName: 'literature' },
        { name: '收获', ladderName: 'harvest' },
      ],
      ladders: [
        {
          levelName: 'Level 1',
          literacyGoal: '350',
          communication: '用所学简单词语句子说话',
          literacyReading: '高效识字，掌握汉字基本规律，理解词句含义',
          literature: '了解中国传统节日及习俗',
          harvest: 'HSK二级',
          bg: '#FB9068',
        },
        {
          levelName: 'Level 2',
          literacyGoal: '800',
          communication: '能日常中文沟通，用长句进行1分钟表达',
          literacyReading: '了解拼音，独立认字，理解长句与50字小短文',
          literature: '了解中国各地特色',
          harvest: 'HSK三级',
          popText: 'PreK - Grade 2',
          bg: '#FFA062',
        },
        {
          levelName: 'Level 3',
          literacyGoal: '1250',
          communication: '能流畅对话，进行2分钟独立表达，完成50字作文',
          literacyReading: '独立识字，书写流畅，理解100字短文',
          literature: '学习中国启蒙文化文学',
          harvest: 'HSK三级',
          popText: 'Grade 2 - Grade 5',
          bg: '#FDBA48',
        },
        {
          levelName: 'Level 4',
          literacyGoal: '1800',
          communication: '能无障碍对话，进行4分钟独立表达，完成100字作文',
          literacyReading: '熟练识字与书写，理解300字短文',
          literature: '学习中国文学史初阶',
          harvest: 'HSK四级',
          bg: '#63B0FC',
        },
        {
          levelName: 'Level 5',
          literacyGoal: '2100',
          communication: '能进入本土对话,进行8分钟表达分享,完成300字作文',
          literacyReading: '字词学习轻松，进入文学作品阅读',
          literature: '学习中国文学史中阶',
          harvest: 'HSK四级',
          bg: '#709BFF',
        },
        {
          levelName: 'Level 6',
          literacyGoal: '2500',
          communication: '能拥有本土对话能力,进行15分钟小演讲,完成500字作文',
          literacyReading: '进入文学作品阅读并能进行分析',
          literature: '学习中国文学史高阶',
          harvest: 'HSK五级',
          bg: '#709BFF',
        },
      ],
    },
  },
}
